// extracted by mini-css-extract-plugin
export default {"whatsapp":"ButtonWhatsapp_whatsapp__0kTC6","icon_whatsapp":"ButtonWhatsapp_icon_whatsapp__4LrYx"};